/* src/modules/dashboard/cards/NumberOfLessonsCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { capitalize } from 'lodash';
import moment from 'moment';

import { Paper } from '@material-ui/core';
import { LineGraph } from '../../components';
import { loadTexts } from '../../../../config/texts';

import {
  changeNumberOfLessonsTimeFrame,
  changeNumberOfLessonsType,
  changeNumberOfLessonsStartDate,
  changeNumberOfLessonsEndDate,
} from '../../actions';
import { getNumLessons } from '../../selectors';
const TEXT_KEY = 'dashboard';

class NumberOfLessonsCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: '',
      endDate: '',
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._timeFrames = [
      { value: 'day', label: this.state.texts.labels.day },
      { value: 'week', label: this.state.texts.labels.week },
      { value: 'month', label: this.state.texts.labels.month },
      { value: 'year', label: this.state.texts.labels.year },
    ];

    this._types = [
      { value: 'requested', label: this.state.texts.labels.requested },
      { value: 'completed', label: this.state.texts.labels.completed },
      { value: 'cancelled', label: this.state.texts.labels.cancelled },
      { value: 'no_show', label: this.state.texts.labels.no_show },
    ];

    this._onTimeFrameChange = this._onTimeFrameChange.bind(this);
    this._onTypeChange = this._onTypeChange.bind(this);
    this._onChangeStartDate = this._onChangeStartDate.bind(this);
    this._onChangeEndDate = this._onChangeEndDate.bind(this);
    this._onClickUpdate = this._onClickUpdate.bind(this);
  }

  componentWillMount() {
    const today = moment();
    const start = today.clone().add(-1, 'month').format('Y-MM-DD');
    const end = today.format('Y-MM-DD');
    this.props.changeNumberOfLessonsStartDate(start);
    this.props.changeNumberOfLessonsEndDate(end);
    this.setState({ startDate: start, endDate: end });
  }

  _onTimeFrameChange(value) {
    this.props.changeNumberOfLessonsTimeFrame(value);
  }

  _onTypeChange(value) {
    this.props.changeNumberOfLessonsType(value);
  }

  _onChangeStartDate(value) {
    this.setState({ startDate: value });
  }

  _onChangeEndDate(value) {
    this.setState({ endDate: value });
  }

  _onClickUpdate() {
    const { startDate, endDate } = this.state;
    this.props.changeNumberOfLessonsStartDate(startDate);
    this.props.changeNumberOfLessonsEndDate(endDate);
  }

  render() {
    const { currentTimeFrame, currentType, lessonsData: { data, labels } } = this.props;
    const { startDate, endDate, texts } = this.state;

    return (
      <Paper>
        <LineGraph
          title={texts.title.lesson_analysis}
          data={data}
          labels={labels}
          label={capitalize(currentType)}
          onTimeFrameChange={this._onTimeFrameChange}
          onTypeChange={this._onTypeChange}
          timeFrames={this._timeFrames}
          types={this._types}
          currentTimeFrame={currentTimeFrame}
          currentType={currentType}
          startDate={startDate}
          endDate={endDate}
          onChangeStartDate={this._onChangeStartDate}
          onChangeEndDate={this._onChangeEndDate}
          onClickUpdate={this._onClickUpdate}
        />
      </Paper>
    );
  }
}

NumberOfLessonsCard.propTypes = {
  changeNumberOfLessonsTimeFrame: PropTypes.func.isRequired,
  changeNumberOfLessonsType: PropTypes.func.isRequired,
  changeNumberOfLessonsStartDate: PropTypes.func.isRequired,
  changeNumberOfLessonsEndDate: PropTypes.func.isRequired,
  currentTimeFrame: PropTypes.string.isRequired,
  currentType: PropTypes.string.isRequired,
  lessonsData: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  currentTimeFrame: state.dashboard.graphs.numberOfLessonsTimeFrame,
  currentType: state.dashboard.graphs.numberOfLessonsType,
  lessonsData: getNumLessons(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  changeNumberOfLessonsTimeFrame: params => dispatch(changeNumberOfLessonsTimeFrame(params)),
  changeNumberOfLessonsType: params => dispatch(changeNumberOfLessonsType(params)),
  changeNumberOfLessonsStartDate: params => dispatch(changeNumberOfLessonsStartDate(params)),
  changeNumberOfLessonsEndDate: params => dispatch(changeNumberOfLessonsEndDate(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NumberOfLessonsCard);



// WEBPACK FOOTER //
// ./src/modules/dashboard/cards/NumberOfLessonsCard/index.js